import CommonViewComponent from './CommonViewComponent';

export default class View extends CommonViewComponent {
    constructor(helper, $container) {
        this.$container = $container || $.create('div');
        this.helper = helper;
        this.elements = [];
    }
}
